import { RuleSet } from "styled-components";
import { continentViewBoxes, continentCodeNames } from "./constants";
import { COUNTRY_DETAILS } from "./countryDetails";
import { RewardCountry } from "./types";

export const getContinentFromId = (continentOrCountryId: string) => {
  if (Object.keys(continentCodeNames).includes(continentOrCountryId)) {
    return continentOrCountryId;
  }

  return COUNTRY_DETAILS[continentOrCountryId]?.continent;
};

export const getContinentViewBox = (continent: string, svg: SVGSVGElement) => {
  if (!continent) {
    return;
  }
  const viewBox = continentViewBoxes[continent];
  if (viewBox.length) {
    svg.setAttribute("viewBox", viewBox.join(" "));
  }
};

export function getIdFromElementOrParent(element?: HTMLElement) {
  if (element.tagName.toLowerCase() === "svg") {
    return;
  }

  const id = element?.id;

  if (id) {
    return id;
  }

  return getIdFromElementOrParent(element?.parentElement);
}

export const getContinentFromViewbox = () => {
  const currentViewbox = document.getElementById("world-map")?.getAttribute("viewBox");

  if (!continentViewBoxes) {
    return [];
  }

  return Object.entries(continentViewBoxes)?.find(([_, viewbox]) => {
    return viewbox.join(" ") === currentViewbox;
  })?.[0];
};

export const changeCountryColour = (countryCode: string, style: RuleSet<object>) => {
  const splitCountries = ["US", "US-main"];

  const element = document.getElementById(countryCode);
  if (element?.tagName.toLowerCase() === "svg") {
    return;
  }

  const id = element?.id;

  if (id) {
    // dealing with the US, where mainland and Alaska are split
    if (splitCountries.includes(countryCode)) {
      splitCountries.forEach((code) => {
        const element = document.getElementById(code);
        element.setAttribute("style", style.toString());
      });
      return;
    }

    const element = document.getElementById(countryCode);
    return element.setAttribute("style", style.toString());
  }
};

export const getIdOrParentIdOfElement = (target: SVGElement) => {
  const id = target?.id || target?.parentElement?.id;
  return id;
};

export const changeContinentColour = (countries: string[], style: RuleSet<object>) => {
  countries?.forEach((countryCode: string) => {
    changeCountryColour(countryCode, style);
  });
};

export const changeCountriesWithRewardsColour = (
  countries: RewardCountry[],
  style: RuleSet<object>,
) => {
  countries.forEach(({ countryCode }) => {
    changeCountryColour(countryCode, style);
  });
};

export const filterRewardCountriesByContinent = (countries: RewardCountry[], continent: string) => {
  return countries.filter((country) => {
    return continentCodeNames[continent].includes(country.countryCode);
  });
};

export const getCountryNameFromId = (id: string) => {
  return COUNTRY_DETAILS[id].country;
};

export const getTooltipWidthOffsetFromName = (name?: string) => {
  return (name?.length || 0) * 4 + 20 || 50;
};

export const getTooltipPosition = (
  e: MouseEvent,
  svg: SVGSVGElement,
  tooltipLengthOffset: number,
) => {
  const svgRect = svg.getBoundingClientRect();

  const x = e.clientX - svgRect.left - tooltipLengthOffset;
  const y = e.clientY - svgRect.top - 75;
  return { top: y, left: x };
};

export const getMapSize = (ref: any) => {
  const map = ref.current.getBoundingClientRect();
  return { height: map.height, width: map.width };
};

export const isCountryWithRewards = (id: string, countriesWithRewardsArray: RewardCountry[]) => {
  return countriesWithRewardsArray.some(({ countryCode }) => countryCode === id);
};

export const getCountryDetails = (countryId: string) => {
  return COUNTRY_DETAILS[countryId];
};
